<template>
  <div class="init-page" :style="{ width: width }">
    <div class="init-page-body">
      <div class="body-img">
        <img :src="img" alt="">
      </div>
      <div class="body-tips">{{ config.tips }}</div>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'init-page',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    width: {
      type: String,
      default: '100%'
    }
  },
  // 局部注册的组件
  components: {},
  // 组件状态值
  data () {
    return {}
  },
  // 计算属性
  computed: {
    img () {
      const url = this.config.img
      if (url && url.includes('https://')) {
        return url
      } else {
        return this.$imgurl + url
      }
    }
  },
  // 侦听器
  watch: {},
  // 组件方法
  methods: {}
}
</script>

<style scoped lang="scss">
.init-page {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  position: absolute;
  inset: 0;
  &-body {
    margin: 100px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    .body-img {
      width: 180px;
      height: 150px;
    }
    .body-tips {
      color: #333333;
      font-weight: 400;
      font-size: 14px;
      margin-top: 16px;
    }
  }
}
</style>
